import { get, mixin, reset } from "../../css/util";

import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  align-self: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: row;
`;

export const Input = styled.input.attrs({ type: "search" })`
  ${reset()};
  ${mixin("font.default", 14, "20px")};
  background: ${get("color.white")};
  border: 1px solid ${get("color.lightGrey")};
  color: ${get("color.text")};
  max-width: 14em;
  padding: 6px ${get("spacing.paddingHalf")};
  width: 100%;
`;

export const SubmitButton = styled.button.attrs({ type: "submit" })`
  ${reset()};
  ${mixin("font.bold", 14, "20px")};
  background: ${get("color.secondary")};
  color: ${get("color.white")};
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 2px;
  padding: 6px ${get("spacing.paddingHalf")};
  transition: opacity ${get("transition.default")};
  white-space: nowrap;

  &:disabled {
    cursor: default;
    opacity: 0.4;
  }
`;

export const Dropdown = styled.div`
  ${reset()};
  background: ${get("color.white")};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  left: 0;
  max-height: 60vh;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 1000;
`;

export const LoadingMessage = styled.p`
  ${reset()};
  ${mixin("font.default", 13, "18px")};
  color: ${get("color.grey")};
  padding: ${get("spacing.paddingHalf")};
`;

export const ResultItem = styled.button.attrs({ type: "button" })`
  ${reset()};
  ${mixin("font.default", 15, "18px")};
  border-top: 1px solid ${get("color.lightGrey")};
  cursor: pointer;
  display: block;
  padding: ${get("spacing.paddingHalf")};
  text-align: left;
  width: 100%;

  &:first-child {
    border-top: 0;
  }
  &:hover {
    background: ${get("color.lightGrey")};
  }
`;

export const ResultName = styled.span`
  ${mixin("font.bold", 15, "18px")};
  color: ${get("color.text")};
  display: inline-block;
  margin-right: 0.5em;
`;

export const ResultReference = styled.span`
  color: ${get("color.grey")};
  display: inline-block;
  &:before {
    content: "-";
    margin-right: 0.5em;
  }
`;

export const ResultCollection = styled.span`
  ${mixin("font.default", 13, "18px")};
  color: ${get("color.grey")};
  display: block;
`;

export const NoResults = styled.p`
  ${reset()};
  ${mixin("font.default", 13, "18px")};
  color: ${get("color.grey")};
  padding: ${get("spacing.paddingHalf")};
`;
